


















import InfoPopup from "@base/Components/InfoPopup.vue";

import {defineComponent} from "@vue/composition-api";

export default defineComponent({
    components: {
        InfoPopup
    },
    props: {
        type: {
            type: String,
            required: true
        },
        title: {
            type: String,
            required: true,
        },
        horizontal: {
            type: Boolean,
            default: true
        }
    },
    setup(props) {
        const elementId = `builder-results-${props.type}`;
        const infoPopupElementId = `builder-results-${props.type}-info`;
        const labelAlign = props.horizontal ? 'right' : 'left';
        const labelColsMd = props.horizontal ? 4 : 12;

        return {
            elementId,
            infoPopupElementId,
            labelAlign,
            labelColsMd,
        }
    }
});
